import { useParams } from "react-router-dom";
import { BlogPost } from "../api/thunks/blogs";
import Markdown from "react-markdown";
import { HeaderNavComponent } from "./header-nav-compontent";
import { SignUpPopup } from "./signup-popup";
import { useScrollProgress } from "../hooks/useScrollProgress";
import { useState, useEffect } from "react";
import { useAppSelector } from "../store/hooks";

export const BlogPostPage = ({ allPosts }: { allPosts: BlogPost[] }) => {
    const { postId, slug } = useParams<{ postId?: string; slug?: string }>();
    const currentPost = allPosts.find(p => p.id === postId);
    const scrollProgress = useScrollProgress();
    const [showSignUpPopup, setShowSignUpPopup] = useState(false);
    const [hasShownPopup, setHasShownPopup] = useState(false);
    const user = useAppSelector((state) => state.user.user);
    
    console.log('currentPost', currentPost, postId, slug);
    console.log('currentPost', currentPost, allPosts);
    
    // Show signup popup when user scrolls 50% and hasn't seen it yet
    const credentials = useAppSelector((state) => state.user.credentials);
    useEffect(() => {
        if (scrollProgress >= 50 && !hasShownPopup && !credentials) {
            setShowSignUpPopup(true);
            setHasShownPopup(true);
        }
    }, [scrollProgress, hasShownPopup, credentials]);
    return (
        <>
            <SignUpPopup closeModal={() => setShowSignUpPopup(false)} isOpen={showSignUpPopup} />
            <div className="min-h-screen p-8">
                <title>PocketQuant | {currentPost?.title}</title>
                <HeaderNavComponent/>
                
                {/* AI Chat Component */}
                <div className="max-w-4xl mx-auto mb-6 bg-white rounded-xl border border-gray-200 shadow-sm">
                    <div className="flex items-center justify-between px-4 py-2 border-b border-gray-100">
                        <div className="flex items-center space-x-2">
                            <div className="w-6 h-6 bg-gradient-to-r from-orange-500 to-orange-600 rounded-full flex items-center justify-center">
                                <svg className="w-3 h-3 text-white" fill="currentColor" viewBox="0 0 24 24">
                                    <path d="M12 1.5C6.2 1.5 1.5 5.7 1.5 10.8c0 1.6.4 3.1 1.2 4.4L1.5 19.5l4.3-1.2c1.3.8 2.8 1.2 4.4 1.2 5.8 0 10.5-4.2 10.5-9.3S17.8 1.5 12 1.5zM8.5 11.5c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1zm3.5 0c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1zm3.5 0c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1z"/>
                                </svg>
                            </div>
                            <span className="text-sm font-medium text-gray-700">PocketQuant AI</span>
                        </div>
                        <span className="text-xs text-gray-500">Ask anything about finance</span>
                    </div>
                    <div className="p-3">
                        <div className="mb-3 max-h-[80px] overflow-y-auto">
                            <div className="flex items-start space-x-2">
                                <div className="flex-shrink-0 w-6 h-6 bg-gray-100 rounded-full flex items-center justify-center mt-1">
                                    <svg className="w-3 h-3 text-gray-600" fill="currentColor" viewBox="0 0 24 24">
                                        <path d="M12 1.5C6.2 1.5 1.5 5.7 1.5 10.8c0 1.6.4 3.1 1.2 4.4L1.5 19.5l4.3-1.2c1.3.8 2.8 1.2 4.4 1.2 5.8 0 10.5-4.2 10.5-9.3S17.8 1.5 12 1.5zM8.5 11.5c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1zm3.5 0c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1zm3.5 0c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1z"/>
                                    </svg>
                                </div>
                                <div className="flex-1 bg-gray-50 rounded-lg px-3 py-2">
                                    <p className="text-xs text-gray-600">Ask me about <strong>{currentPost?.title}</strong> or any financial topic - earnings, ratios, market trends, etc.</p>
                                </div>
                            </div>
                        </div>
                        <div className="flex space-x-2">
                            <input 
                                type="text" 
                                placeholder="Type your question..."
                                className="flex-1 px-3 py-2 text-sm border border-gray-200 rounded-lg focus:ring-1 focus:ring-orange-500 focus:border-orange-500 outline-none bg-gray-50"
                                onKeyPress={(e) => e.key === 'Enter' && setShowSignUpPopup(true)}
                            />
                            <button 
                                onClick={() => setShowSignUpPopup(true)}
                                className="px-4 py-2 bg-orange-500 text-white rounded-lg hover:bg-orange-600 transition duration-200 text-sm flex items-center"
                            >
                                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                                    <path d="M10.894 2.553a1 1 0 00-1.788 0l-7 14a1 1 0 001.169 1.409l5-1.429A1 1 0 009 15.571V11a1 1 0 112 0v4.571a1 1 0 00.725.962l5 1.428a1 1 0 001.17-1.408l-7-14z"></path>
                                </svg>
                            </button>
                        </div>
                        <p className="text-xs text-gray-400 mt-2 text-center">
                            <button onClick={() => setShowSignUpPopup(true)} className="text-orange-500 hover:underline">Sign up</button> 
                            for unlimited AI responses
                        </p>
                    </div>
                </div>

                <h1 className="text-center font-bold">{currentPost?.title}</h1>
                <div className="mt-4 text-left">
                    <div className="text-sm text-gray-500 flex items-center">
                        <address><span className="font-bold">Author:</span>PQ Automations</address>
                        <span className="mx-2">|</span>
                        <time> <span className="font-bold">Date:</span> {currentPost?.createdAt} EST</time>
                        <span className="mx-2">|</span>
                        <span className="font-bold mr-2">Tags:</span>
                        {currentPost?.tags?.split(',').map((tag, index) => (
                            <span key={index} className="inline-block bg-gray-200 rounded-full px-3 py-1 text-sm font-semibold text-gray-700 mr-2 mb-2">
                                {tag}
                            </span>
                        ))}
                    </div>
                    <div className="mt-4 text-gray-700">
                        <Markdown
                            unwrapDisallowed
                            components={{
                                p: ({ node, ...props }) => (
                                    <p key={`p-`} className="mb-4" {...props} />
                                ),
                                ul: ({ node, ...props }) => (
                                    <ul key={`ul-`} className="list-disc ml-5" {...props} />
                                ),
                                li: ({ node, ...props }) => (
                                    <li key={`li-`} className="mb-1" {...props} />
                                ),
                                a: ({ node, ...props }) => (
                                    <a key={`a-`} className="text-blue-500 hover:underline" {...props} />
                                ),
                                
                            }}
                        >
                            {currentPost?.content}
                        </Markdown>
                    </div>
                </div>
            </div>
        </>
    )
}